import { TWhiteLabelStore } from '../white-label.model';
import { resolveItemBgHover } from './resolve-item-bg-hover';

export function setItemBgHover(themeWrapper: HTMLBodyElement, whiteLabel: TWhiteLabelStore): void {
  themeWrapper.style.setProperty('--itemBgHover', resolveItemBgHover(whiteLabel.data));
}
